<template>
  <div id="add-item-to-basket-overlay" class="add-item-to-basket-overlay--mobile" :class="{ 'is-single' : templateEvent == 'tpl.item', 'add-item-to-basket-overlay--mobile': isMobile }">
    <div class="modal fade">
      <div class="modal-dialog" :class="{ 'has-crossselling' : hasCrossselling }" role="document">
        <div class="modal-content">
          <div class="modal-header-mobile">
            <button type="button" class="close ml-0 pl-1" data-dismiss="modal" :aria-label="$translate('Ceres::Template.closeIcon')">
              <svg width="18" height="18"><use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
            </button>
            <div class="headline">
              <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                <circle cx="25.5" cy="25.5" r="25.5" fill="#333333"/>
                <path d="M36 18L22.25 32L16 25.6364" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Artikel ist im Warenkorb</span>
            </div>
            <div class="button-wrapper row">
              <div class="col-6">
                <a v-waiting-animation-infinite :href="urls.basket" rel="nofollow" class="btn btn-outline-primary btn-medium mr-2">
                  {{ $translate("Ceres::Template.singleItemBasket") }}
                </a>
              </div>
              <div class="col-6">
                <a v-waiting-animation-infinite :href="urls.checkout" rel="nofollow" class="btn btn-primary btn-medium">
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  {{ $translate("Ceres::Template.singleItemCheckout") }}
                </a>
              </div>
            </div>
          </div>
          <div v-if="hasCrossselling" class="modal-body-mobile">
            <div class="body-headline">Gleich mitbestellen</div>
            <div class="items-wrapper">
              <template v-for="item in items">
                <category-item :item-data="item.data" :key="item.id" :is-overlay="true"></category-item>
              </template>
            </div>
          </div>
          <div v-if="hasCrossselling" class="modal-footer-mobile">
            <button type="button" data-dismiss="modal" :aria-label="$translate('Ceres::Template.closeIcon')">
              Weiter shoppen
            </button>
            <a v-waiting-animation-infinite :href="urls.basket" rel="nofollow">
              Zum Warenkorb
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { mapState } from "vuex";
import { Swiper } from 'swiper';
const ModalService  = require("ceres/app/services/ModalService");
const ApiService    = require("ceres/app/services/ApiService");

export default {
	name: "add-item-to-basket-overlay",

	props: {
    defaultTimeToClose: {
      type: Number,
      default: 15
    },
    hasCrossselling:{
      type: Boolean,
      default: false
    },
    items:{
      type: Array,
    }
  },

  data()
  {
    return {
      price: 0,
      basketItem: null,
      countAdditionalBasketItems: 0,
      displaySwiper: false,
      isMobile: false,
    };
  },

  mounted()
  {
    if (App.config.basket.addItemToBasketConfirm === "overlay")
    {
      ApiService.listen("AfterBasketItemUpdate", data =>
      {
        const updatedBasketItem = data.basketItems[0];

        if (!this.isBasketItemQuantityUpdate)
        {
          const basketItem = this.basketItems.find(item => item.id === updatedBasketItem.id) || {};

          this.showItem(basketItem);
        }
      });

      ApiService.listen("AfterBasketItemAdd", data =>
      {
        this.showItem(data.basketItems[0], data.basketItems.length - 1);
      });
    }

    this.$nextTick(() => {
      this.isMobile = window.innerWidth < 768
    });
  },

  computed:
      {
        ...mapState({
          basketItems: state => state.basket.items,
          isBasketItemQuantityUpdate: state => state.basket.isBasketItemQuantityUpdate
        }),

        isLastBasketEntrySet()
        {
          return !isNullOrUndefined(this.basketItem);
        },

        variation()
        {
          if (this.basketItem)
          {
            return this.basketItem.variation ? this.basketItem.variation.data : null;
          }

          return null;
        },

        itemName()
        {
          if (this.isLastBasketEntrySet)
          {
            return this.$options.filters.itemName(this.variation);
          }

          return "";
        },

        imageUrl()
        {
          if (this.isLastBasketEntrySet)
          {
            const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

            return this.$options.filters.itemImage(images);
          }

          return "";
        },

        imageAlternativeText()
        {
          if (this.isLastBasketEntrySet)
          {
            const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

            return this.$options.filters.itemImageAlternativeText(images);
          }

          return "";
        },

        urls()
        {
          return {
            basket: App.urls.basket,
            checkout: App.urls.checkout
          }
        },

        shownOrderProperties()
        {
          return this.basketItem.basketItemOrderParams.filter(property =>
          {
            return !!this.variation.properties.find(prop => prop.propertyId == property.propertyId);
          });
        },

        templateEvent(){
          return App.templateEvent;
        }
      },

  methods:
      {
        showItem(basketItem, countAdditionalBasketItems)
        {
          this.basketItem = basketItem;
          this.countAdditionalBasketItems = countAdditionalBasketItems;
          this.price = basketItem.price;

          ModalService
              .findModal(document.getElementById("add-item-to-basket-overlay"))
              .show();

          // init slider

          let _this = this

          setTimeout(function(){
            if ($('.add-to-basket__crossselling--swiper').length) {

              var addToBasketSwiper;

              setTimeout(function(){
                if(typeof addToBasketSwiper !== "undefined"){
                  addToBasketSwiper.destroy();
                  addToBasketSwiper = undefined;
                }
                addToBasketSwiper = new Swiper('.add-to-basket__crossselling--swiper', {
                  navigation: {
                    nextEl: ".add-to-basket__crossselling .swiper-button-next",
                    prevEl: ".add-to-basket__crossselling .swiper-button-prev"
                  },
                  spaceBetween: 14,
                  loop: false,
                  slidesPerView: 2,
                  centeredSlides: false,
                  pagination: {
                    el: ".add-to-basket__crossselling .swiper-pagination",
                    type: "fraction"
                  },
                  breakpoints: {
                    587: {
                      slidesPerView: 2,
                      spaceBetween: 5
                    },
                    767: {
                      slidesPerView: 2,
                      spaceBetween: 5
                    },
                    991: {
                      slidesPerView: 3,
                      spaceBetween: 5
                    }
                  },
                  on: {
                    init: function () {
                      setTimeout(function(){
                        if($('.add-to-basket__crossselling .swiper-pagination-current').text() == 1 && $('.add-to-basket__crossselling .swiper-pagination-total').text() == 1){
                          $('.add-to-basket__crossselling .swiper-controls').hide();
                        }
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                      }, 50);
                    },
                    afterInit: function() {
                      _this.displaySwiper = true
                    }
                  }
                });
              }, 50);
            }
          }, 500);
        }
      }
}
</script>
